import { matchPath, useLocation } from 'react-router-dom';

import { privatePaths } from 'router/paths';

export const useMatchPathParams = () => {
  const { pathname } = useLocation();
  const match = matchPath(pathname, {
    path: privatePaths,
    exact: true,
    strict: false,
  });

  return match?.params || {};
};
